import { useEffect, useState } from "react";
import { YSButton } from "../../../uikit/YSButton";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  BtnGroupStyle,
  ContentStyle,
  SummaryBox,
  SummaryBoxScroll,
  SummaryInfo,
} from "../../../Theme";
import ShowIcon from "@mui/icons-material/Add";
import YSCheckBox from "../../../uikit/YSCheckBox";
import { Formik, Form } from "formik";
import HideIcon from "@mui/icons-material/Remove";
import TabsNav from "../../../components/TabsNav";
import { useLocation, useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import AdverseEffectPOPUp from "../../../components/AdverseEffectPOPUp";
import { sendReprintRefax } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import DrugAllergyInteractions from "../../../components/DrugAllergyInteractions";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import DrugToFoodInteractionPopUp from "../../../components/DrugToFoodInteractionPopUp";
const initialStateConfirmReprintRefax = {
  rePrint: "",
  reFax: "",
};

export default function ConfirmReprintRefax(props: any) {
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [openInfo, setOpenInfo] = useState(false);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [adverseEffectPopUp, setAdverseEffectPopUp] = useState(false);
  const [rePrintRefaxConfirm, setPrintRefaxConfirm] = useState(false);
  const [stateData, setStateData] = useState<any>({});
  const [valuesData, setValuesData] = useState<any>(null);
  const [patientEduPopUp, setPatientEduPopUp] = useState(false);
  const [foodPopUp, setFoodPopUp] = useState(false);
  const [drugIdforadverse, setDrugIdForAdverse] = useState("");
  const [statusStateData, setStatusStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleShowAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(true);
  };
  const handleHideAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(false);
  };
  const handleShowRePrintRefaxConfirmPopUpClick = () => {
    setPrintRefaxConfirm(true);
  };
  const handleHideRePrintRefaxConfirmPopUpClick = () => {
    setPrintRefaxConfirm(false);
  };
  const handleShowPatientEduPopUpClick = () => {
    setPatientEduPopUp(true);
  };
  const handleHidePatientEduPopUpClick = () => {
    setPatientEduPopUp(false);
  };
  const handleShowFoodPopUpClick = () => {
    setFoodPopUp(true);
  };
  const handleHideFoodPopUpClick = () => {
    setFoodPopUp(false);
  };
  const handleInfoClick = () => {
    setOpenInfo(!openInfo);
  };
  const submitConfirmReprintRefax = async (values: any) => {
    try {
      const params = new URLSearchParams();
      params.append(
        "reprint",
        values?.rePrint == "" ? "false" : values?.rePrint
      );
      params.append("refax", values?.reFax == "" ? "false" : values?.reFax);
      const bodyData = {
        prescriptionFormList: [stateData],
        patientId: sessionStorage.getItem("patientId"),
        userDetails: {
          doctorId: localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await sendReprintRefax(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (values?.rePrint) {
          setReportUrl(result?.data?.response[0]?.url);
          setPrintActive(true);
        } else if (values?.reFax) {
          setReportUrl("");
          setPrintActive(false);

          setStatusStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.reFax?.map((each: any) => {
                return (
                  <Box>
                    <Typography
                      component={"div"}
                      fontWeight={600}
                      variant={"body2"}
                    >
                      <strong> Drug resent by Fax: </strong>
                    </Typography>

                    <Typography
                      component={"div"}
                      fontWeight={600}
                      variant={"body2"}
                      paddingLeft={2}
                    >
                      {" - "} {each}
                    </Typography>
                  </Box>
                );
              }),
              variant: "success",
              open: true,
            };
          });
          setTimeout(() => {
            navigate("/newrxpad");
          }, 4000);
        }
      } else {
        setPrintActive(false);
        setStatusStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setPrintActive(false);
      setStatusStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again after sometime!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  useEffect(() => {
    if (state) {
      setStateData(state);
    }
  }, [state]);
  return (
    <>
      <TabsNav />
      <ContentStyle>
        {printActive ? (
          <>
            <Grid item xs={12}>
              <iframe
                src={`${REPORT_BASE_URL}${reportUrl}`}
                height="500px"
                width="920px"
                title="PrintReport"
              />
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    navigate("/medicationshistory");
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </>
        ) : (
          <Formik
            initialValues={initialStateConfirmReprintRefax}
            onSubmit={(values) => {
              handleShowRePrintRefaxConfirmPopUpClick();
              setValuesData(values);
              // submitConfirmReprintRefax(values);
            }}
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                {" "}
                <Grid
                  container
                  item
                  xs={12}
                  spacing={2}
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  {" "}
                  <Grid item xs={12}>
                    <Typography component="h6" color="primary" variant="h6">
                      Confirm Reprint/Refax
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>
                <SummaryInfo>
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    {" "}
                    <Grid item xs={12} md={6}>
                      <Typography
                        component="div"
                        color={"primary"}
                        variant="subtitle2"
                        fontWeight={600}
                      >
                        Allergy and Drug Interaction's
                      </Typography>{" "}
                    </Grid>
                    <Grid item xs={12} md={6} textAlign={"right"}>
                      <YSButton
                        onClick={handleInfoClick}
                        className=""
                        children={"Show"}
                        size={"small"}
                        type="button"
                        variant="contained"
                        startIcon={openInfo ? <HideIcon /> : <ShowIcon />}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Collapse in={openInfo}>
                        <DrugAllergyInteractions eachData={stateData} />
                      </Collapse>
                    </Grid>
                  </Grid>{" "}
                </SummaryInfo>
                <SummaryBoxScroll>
                  <SummaryBox>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={2}
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <Grid item xs={12} md={4}>
                        <Box className="lblval chk">
                          <YSCheckBox
                            className="fill checkbox"
                            name="OnPriority"
                            label=""
                          />{" "}
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Rx No
                          </Typography>
                          <Typography component="div" variant="body2">
                            {stateData?.rxNumber}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Rx Date
                          </Typography>
                          <Typography component="div" variant="body2">
                            {stateData?.rxDate}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Fmlry. Status
                          </Typography>
                          <Typography component="div" variant="body2">
                            {stateData?.formularyStatus}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <Box className="lblval">
                          <Typography
                            component="div"
                            variant="body2"
                            color={"primary"}
                            fontWeight={600}
                          >
                            {stateData?.drugDescription}
                          </Typography>
                          {stateData?.deaClassCode && (
                            <Typography
                              component="div"
                              className="ScheduledDrugLabel"
                              variant="body2"
                            >
                              {stateData?.deaClassCode}
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Co-Pay
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.copay}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            SIG
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.sig}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Qualifier
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.qtyQualifier}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Quantity
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.quantity}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            No. Of Refills
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.refills}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Substitutions
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.substitution}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="div"
                            variant="body2"
                            fontWeight={600}
                          >
                            Note to Pharmacist
                          </Typography>{" "}
                          <Typography
                            component="div"
                            variant="body2"
                          ></Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Pharmacy
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {stateData?.pharmacyDetails?.pharmacyName}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className={"checkboxgrp"}>
                          <YSCheckBox
                            className="fill"
                            name="rePrint"
                            label="Reprint"
                          />
                          <YSCheckBox
                            className="fill"
                            name="reFax"
                            label="Refax"
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className="btns">
                          <YSButton
                            className={""}
                            children={"Adverse Effects"}
                            onClick={handleShowAdverseEffectPopUpClick}
                            variant={"contained"}
                            size={"medium"}
                          />{" "}
                          <YSButton
                            className={""}
                            children={"Drug to Food Interactions"}
                            onClick={() => {
                              setDrugIdForAdverse(stateData?.drugId);
                              handleShowFoodPopUpClick();
                            }}
                            variant={"contained"}
                            size={"medium"}
                          />
                          <YSButton
                            className={""}
                            children={"Patient Education"}
                            onClick={handleShowPatientEduPopUpClick}
                            variant={"contained"}
                            size={"medium"}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </SummaryBox>
                </SummaryBoxScroll>{" "}
                <Grid
                  container
                  item
                  xs={12}
                  spacing={1}
                  alignItems="top"
                  justifyContent="center"
                  gap={3}
                >
                  {" "}
                  <Grid item xs={12} textAlign="right" marginTop={3}>
                    {" "}
                    <YSButton
                      onClick={() => {
                        navigate("/newrxpad");
                      }}
                      className=""
                      children={"Back to RxPad"}
                      size={"large"}
                      type="button"
                      color="primary"
                      variant="outlined"
                    />{" "}
                    <YSButton
                      onClick={null}
                      className=""
                      children={"Reprint/Refax"}
                      size={"large"}
                      type="submit"
                      color="primary"
                      variant="contained"
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
      {/* Adverse Effect */}
      <DialogPopup
        title="Adverse Effects"
        windowsize={"sm"}
        show={adverseEffectPopUp}
        handleShowPopupClick={handleShowAdverseEffectPopUpClick}
        handleHidePopupClick={handleHideAdverseEffectPopUpClick}
      >
        <AdverseEffectPOPUp drugIdforadverse={stateData?.drugId} />
      </DialogPopup>
      {/* Reprint / Refax Confirmation */}
      <DialogPopup
        title="Reprint/Refax Confirmation"
        windowsize={"sm"}
        show={rePrintRefaxConfirm}
        handleShowPopupClick={handleShowRePrintRefaxConfirmPopUpClick}
        // handleHidePopupClick={handleHideRePrintRefaxConfirmPopUpClick}
      >
        <Grid
          container
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
          gap={3}
        >
          <Grid item xs={12} textAlign="left" marginTop={2}>
            <Typography variant="subtitle1">
              This action will Re-print/Re-fax the medication as an original
              prescription, not as a watermarked copy.
            </Typography>
            <Typography variant="subtitle1" marginTop={2}>
              Are you sure you want to proceed?
            </Typography>
          </Grid>

          <Grid item xs={12} textAlign="right">
            <YSButton
              onClick={handleHideRePrintRefaxConfirmPopUpClick}
              className=""
              children={"Cancel"}
              size={"large"}
              type="button"
              color="primary"
              variant="outlined"
            />{" "}
            <YSButton
              onClick={() => {
                handleHideRePrintRefaxConfirmPopUpClick();
                submitConfirmReprintRefax(valuesData);
              }}
              className=""
              children={"OK"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
        </Grid>
      </DialogPopup>
      {/* Food interactions */}
      <DialogPopup
        title="Drug to Food Interactions"
        windowsize={"sm"}
        show={foodPopUp}
        handleShowPopupClick={handleShowFoodPopUpClick}
        handleHidePopupClick={handleHideFoodPopUpClick}
      >
        <DrugToFoodInteractionPopUp drugIdforadverse={drugIdforadverse} />
      </DialogPopup>
      {/* Patient Education */}
      <DialogPopup
        title="Patient Education"
        windowsize={"sm"}
        show={patientEduPopUp}
        handleShowPopupClick={handleShowPatientEduPopUpClick}
        handleHidePopupClick={handleHidePatientEduPopUpClick}
      >
        <Typography>Info not available</Typography>
      </DialogPopup>
      <YSSnackBar
        message={statusStateData.message}
        variant={statusStateData.variant}
        open={statusStateData.open}
        handleClose={() => {
          setStatusStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
